import {
  createBlockNode,
  createSectionNode,
  createInvestmentGroupNode,
  createInvestmentHeaderNode,
  createInvestmentTotalNode,
} from './createBlockNode';

export { default as BlockNodeView } from './BlockNodeView';
export { createBlockNode, createSectionNode } from './createBlockNode';

/** All block node extensions for the quote editor */
export const blockNodeExtensions = [
  // Atom page blocks (complex custom UI)
  createBlockNode('coverBlock'),
  createBlockNode('teamBlock'),
  createBlockNode('footerBlock'),
  createBlockNode('signaturePageBlock'),

  // Splittable section nodes (native Tiptap content, Pages can split across pages)
  createSectionNode('contentPageSection'),
  createSectionNode('planVanAanpakSection'),

  // Investment: group wrapper + header + total (tables are native via TableKit)
  createInvestmentGroupNode(),
  createInvestmentHeaderNode(),
  createInvestmentTotalNode(),

  // Generic blocks
  createBlockNode('textBlock'),
  createBlockNode('tableBlock'),
  createBlockNode('imageBlock'),
  createBlockNode('videoBlock'),
  createBlockNode('productBlock'),
  createBlockNode('pricingBlock'),
  createBlockNode('dividerBlock'),
  createBlockNode('spacerBlock'),
  createBlockNode('signatureBlock'),
  createBlockNode('headerBlock'),
];
